
import React from "react";
import { IMerchItem } from "../../data";
import styles from "../../assets/style.module.css";

export interface ProductCardProps {
    item: IMerchItem;
    action?: React.ReactNode;
}

function ProductCard({ item, action }: ProductCardProps) {
    return (<div className={styles["product"]}>
        <div className={styles["product-img"]}>
            <img src={item.img} alt={item.name} loading="lazy" />
            {item.badge && (<span className={styles["work-float"]}><span className={styles["chip"]}>{item.badge}</span></span>)}
        </div>
        <div className={styles["product-text"]}>
            <span className={styles["product-name"]}>{item.name}</span>
            <span className={styles["product-price"]}>${item.price.toFixed(2)}</span>
        </div>
        <span className={styles["tag"]}>[ {item.category} ]</span>
        {action}
    </div>);
}

export default ProductCard;
